<div class="assisted-browsing-container" #assistedBrowsingContainer>
  <div class="title-bar">
    <div class="header">
      <svg-icon class="ab-icon" icon="assisted-browsing"></svg-icon>
      <div class="ab-title">{{ 'bcAssistedBrowsingPanel.title' | translate }}</div>
      <button class="btn btn-light btn-stop"
              data-automation-id="assistedbrowsing-cancel"
              (click)="stop()">
        <svg-icon *ngIf="isStarted" class="btn-icon" icon="stop"></svg-icon>
        {{ (isStarted ? 'bcAssistedBrowsingPanel.stopButton' : 'bcAssistedBrowsingPanel.cancelButton') | translate }}
      </button>
    </div>
    <navigation-bar *ngIf="isStarted" [visitorTabs]="visitorTabs" (selectionChange)="onNavigationChange($event)" [currentUrl]="activePageUrl"></navigation-bar>
  </div>

  <div class="frame-container">
    <no-visitor-monitor-splash-screen *ngIf="!hasVisitorMonitor"></no-visitor-monitor-splash-screen>
    <waiting-for-permission-splash-screen *ngIf="isWaitingForPermission()"></waiting-for-permission-splash-screen>
    <assisted-browsing-frame *ngFor="let pageViewId of pageViews.keys()"
                             [pageViewId]="pageViewId"
                             [ngClass]="{ 'inactive-frame': pageViewId !== activePageViewId }"
                             #assistedBrowsingFrame></assisted-browsing-frame>
  </div>

  <div *ngIf="isStarted && hasVisitorMonitor" class="footer-panel">
    <div class="footer-buttons">
      <button class="btn btn-light btn-footer"
              [ngClass]="{ 'btn-active': isHighlightActive }"
              [disabled]="!isStarted"
              (click)="toggleHighlight()">
        <svg-icon class="btn-icon" icon="highlighter"></svg-icon>
        <span>{{ 'bcAssistedBrowsingPanel.highlighterButton' | translate }}</span>
      </button>
      <div class="line-separator"></div>
      <svg-icon class="btn-footer btn-fullscreen" [icon]="isFullscreen() ? 'exit-fullscreen' : 'fullscreen'" (click)="toggleFullscreen()"></svg-icon>
    </div>
  </div>
</div>
